import { Button, Grid, GridCell, Heading, Text } from '@flixbus/honeycomb-react';
import { login } from '../../helpers/auth';
import PageTitle from '../pageTitle/PageTitle';

const LoginMessage = () => (
    <>
        <PageTitle title="Login" />
        <Grid extraClasses="hcr-space-8-top">
            <GridCell colSpan={12} extraClasses="hcr-has-text-centered">
                <Heading size={2}>Data Sharing Portal Login</Heading>
                <Text>Please log in with your Flix account to continue.</Text>
                <Button appearance="primary" extraClasses="hcr-space-4-top" onClick={login}>
                    Login
                </Button>
            </GridCell>
        </Grid>
    </>
);

export default LoginMessage;
